import React from 'react';
import styles from './OpenGraphCard.module.scss';

const OpenGraphCard = ({
  data,
  className = '',
  compact = false,
  onClick = null,
}) => {
  if (!data) return null;

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(data);
    }
  };

  const cardContent = (
    <div
      className={`${styles.openGraphCard} ${compact ? styles.compact : ''} ${className}`}
    >
      <div className={styles.imageContainer}>
        {data.image ? (
          <img
            src={data.image}
            alt={data.title}
            className={styles.image}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div className={styles.fallbackIcon} aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.828 10.172a4 4 0 10-5.656 5.656l1.414-1.414a2 2 0 112.828-2.828l1.414-1.414z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.172 13.828a4 4 0 105.656-5.656l-1.414 1.414a2 2 0 11-2.828 2.828l-1.414 1.414z"
              />
            </svg>
          </div>
        )}
      </div>

      <div className={styles.content}>
        <div className={styles.siteName}>
          {data.siteName}
          {data.isClientSide && (
            <span
              className={styles.clientSideIndicator}
              title="Fast client-side preview"
            >
              ⚡
            </span>
          )}
          {data.isFallback && (
            <span
              className={styles.fallbackIndicator}
              title="Basic link preview"
            >
              🔗
            </span>
          )}
          {data.isBlocked && (
            <span
              className={styles.blockedIndicator}
              title="Domain blocked by bot protection"
            >
              🚫
            </span>
          )}
          {data.isRateLimited && (
            <span
              className={styles.rateLimitedIndicator}
              title="Rate limited - try again later"
            >
              ⏱️
            </span>
          )}
        </div>
        <h4 className={styles.title}>{data.title}</h4>
        {!compact && data.description && (
          <p className={styles.description}>{data.description}</p>
        )}
        <div className={styles.url}>{data.url}</div>
      </div>

      {!compact && (
        <div className={styles.arrow}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M6 12L10 8L6 4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
    </div>
  );

  if (onClick) {
    return (
      <button className={styles.button} onClick={handleClick} type="button">
        {cardContent}
      </button>
    );
  }

  return (
    <a
      href={data.url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
    >
      {cardContent}
    </a>
  );
};

export default OpenGraphCard;
